function carousel(name, autoplay, interval, centerMode) {
    document.querySelectorAll(name).forEach((carousel) => {
        var focusValue = centerMode ? 'center' : 0;

        var standardCarousel = new Splide(carousel, {
            pagination: true,
            arrows: false,
            autoplay: autoplay,
            interval: interval,
            pauseOnHover: true,
            mediaQuery: 'min',
            gap: '32px',
            focus: focusValue,
            autoWidth: true,
            type: 'loop',
            flickMaxPages: 1,
            flickPower: 400,
            breakpoints: {
                0: {
                    perPage: 1
                },
                481: {
                    perPage: 2,
                }
            }
        });

        standardCarousel.mount()

        var slideArrows = document.querySelector(`.splide__arrows[data-slider="${name.slice(1)}"]`);
        if (slideArrows) {

            // update aria-controls
            var ariaControlsId = document.querySelector(name).querySelector('.splide__track').id;
            slideArrows.querySelector('.splide__arrow--prev').setAttribute('aria-controls', ariaControlsId);
            slideArrows.querySelector('.splide__arrow--next').setAttribute('aria-controls', ariaControlsId);

            slideArrows.addEventListener('click', function (e) {
                if (slideArrows.querySelector('.splide__arrow--prev').contains(e.target)) {
                    standardCarousel.go('<');
                }

                if (slideArrows.querySelector('.splide__arrow--next').contains(e.target)) {
                    standardCarousel.go('>');
                };
            });
        }
    });

}